import { nanoid } from "nanoid";
import { Tasks } from "../Tasks";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  enabled: false,
  notifyAllDevices: true,
  devicesToNotify: {},
  tasks: [
    {
      id: nanoid(),
      type: Tasks.scheduled_monitoring,
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      startTime: { hour: 8, minute: 0 },
      endTime: { hour: 18, minute: 0 }
    }
  ]
};

const schedulerSlice = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    changeEnabled(state, { payload }) {
      state.enabled = payload;
    },
    addTask(state, { payload }) {
      state.tasks.push(payload);
    },
    updateTask(state, { payload }) {
      state.tasks = state.tasks.map((task) => {
        if (task.id === payload.id) {
          return { ...task, ...payload };
        }
        return task;
      });
    },
    removeTask(state, { payload }) {
      state.tasks = state.tasks.filter((task) => task.id !== payload.id);
    },
    changeNotifyAllDevices(state, { payload }) {
      state.notifyAllDevices = payload;
    },
    addDeviceToNotify(state, { payload }) {
      state.devicesToNotify[payload.jid] = payload;
    },
    removeDeviceToNotify(state, { payload }) {
      delete state.devicesToNotify[payload.jid];
    }
  }
});

export { schedulerSlice };
export default schedulerSlice.reducer;
